import { all } from 'redux-saga/effects'
import { saga as tooltipSaga } from 'gnos-tooltip'
import { saga as tablesSaga } from 'gnos-tables'

import apiSaga from '../services/api/saga'
import authorizationSaga from '../services/authorization/saga'
import routingSaga from '../services/routing/saga'
import scenesSagas from '../scenes/sagas'
import translationsSaga from '../services/translations/saga'
import socketSaga from '../services/socket/saga'
import logActionSaga from '../services/logAction/saga'
import appStateSaga from '../services/appState/saga'

/**
 * Root generator for all application sagas
 */
export default function* () {
    yield all([
        apiSaga(),
        authorizationSaga(),
        routingSaga(),
        scenesSagas(),
        translationsSaga(),
        tooltipSaga(),
        tablesSaga(),
        socketSaga(),
        logActionSaga(),
        appStateSaga(),
    ])
}
